export const ADMIN_USERS_PAGE_SIZE = 25;

export type AdminUserSortKey =
  | "applicant"
  | "business"
  | "type"
  | "status"
  | "requests"
  | "registered";

export type AdminUserSortDir = "asc" | "desc";

export type AdminUserApiSortKey =
  | "contact_name"
  | "company_name"
  | "access_role"
  | "status"
  | "access_request_count"
  | "created_at";

const UI_TO_API_SORT: Record<AdminUserSortKey, AdminUserApiSortKey> = {
  applicant: "contact_name",
  business: "company_name",
  type: "access_role",
  status: "status",
  requests: "access_request_count",
  registered: "created_at",
};

export function adminUserSortToApi(key: AdminUserSortKey): AdminUserApiSortKey {
  return UI_TO_API_SORT[key];
}

export function adminUsersResultRangeLabel(
  page: number,
  pageSize: number,
  total: number,
): string {
  if (total === 0) {
    return "Showing 0 users";
  }
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);
  if (start === end) {
    return `Showing ${start} of ${total}`;
  }
  return `Showing ${start}–${end} of ${total}`;
}

export function adminUsersPageCount(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}

export function adminUserSortColumnLabel(key: AdminUserSortKey): string {
  switch (key) {
    case "applicant":
      return "Applicant";
    case "business":
      return "Business";
    case "type":
      return "Type";
    case "status":
      return "Status";
    case "requests":
      return "Requests";
    case "registered":
      return "Registered";
    default:
      return key;
  }
}
